// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import {
  CUSTOM_ELEMENTS_SCHEMA,
  Component,
  DestroyRef,
  inject,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import {
  APICallGateComponent,
  ErrorBehaviors,
} from '../../../shared/components/api-call-gate.component';
import { SystemOverviewService } from '../../services/systemOverview.service';
import { SystemOverviewSwitchComponent } from '../system-overview-switch/system-overview-switch.component';
import { PortalWebAppConfigurationService } from '../../services/portal-web-app-configuration.service';
import { MR_MODALITY_ID } from '../../../shared/utils/modalityHelpers';
import { SystemDetailsModel } from 'src/app/api/remote-api/.portal.generated/models';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-system-overview',
  templateUrl: './system-overview.component.html',
  styleUrls: ['./system-overview.component.scss'],
  standalone: true,

  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    APICallGateComponent,
    TranslateModule,
    SystemOverviewSwitchComponent,
  ],
})
export class SystemOverviewComponent {
  errorBehaviors = [ErrorBehaviors.Reload, ErrorBehaviors.Retry];
  private static systemDetails = {} as SystemDetailsModel;
  private readonly destroyRef = inject(DestroyRef);

  constructor(
    protected readonly systemOverviewService: SystemOverviewService,
    private readonly portalWebAppConfigurationService: PortalWebAppConfigurationService,
  ) {
    SystemOverviewComponent.systemDetails = {} as SystemDetailsModel;
    this.systemOverviewService.systemDetails.data$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((details) => {
        if (
          details !== undefined &&
          SystemOverviewComponent.systemDetails.systemSerialNumber !==
            details.systemSerialNumber &&
          SystemOverviewComponent.systemDetails.systemMaterialNumber !==
            details.systemMaterialNumber
        ) {
          SystemOverviewComponent.systemDetails = details;
          if (details?.modalityId === MR_MODALITY_ID) {
            let modalityName;
            this.systemOverviewService.currentModalityName$.subscribe(
              (name) => {
                modalityName = name;
              },
            );
            this.systemOverviewService.magnetType
              .request({
                systemMaterialNumber: details.systemMaterialNumber,
                systemSerialNumber: details.systemSerialNumber,
                modality: modalityName ?? '',
              })
              .subscribe((magnetType) => {
                this.portalWebAppConfigurationService.getUsefulAppConfiguration(
                  {
                    systemMaterialNumber: details?.systemMaterialNumber,
                    modalityId: details?.modalityId,
                    country: details?.customerLocation.split(',')[0] ?? '',
                    magnetType: magnetType ?? '',
                  },
                );
              });
          } else {
            this.portalWebAppConfigurationService.getUsefulAppConfiguration({
              systemMaterialNumber: details?.systemMaterialNumber,
              modalityId: details?.modalityId,
              country: details?.customerLocation.split(',')[0] ?? '',
            });
          }
        }
      });
  }
}
